
import * as Modules from './module-registry';

function setupModules(): void {
  Modules.setupElectronicMedicationAdministration();
  Modules.setupElectronicPatientChart();
  Modules.setupExamCollection();
  Modules.setupChemotherapy();
  Modules.setupUserDetail();
  Modules.setupSendExamSample();
  Modules.setupDoubleConference();
  Modules.setupPhysicianSchedule();
  Modules.setupCpoe();
  Modules.setupSurgical();
  Modules.setupPatientDisplacement();
  Modules.setupPatientExchange();
  Modules.setupMealDelivery();
}

export {
  setupModules
}
